import { classMetadataKey } from './common';
export function ApiConfig(config) {
    return function (target, key = classMetadataKey) {
        const metadata = Reflect.getMetadata('api-config', target, key);
        const nextMetadata = metadata ? [...metadata, config] : [config];
        Reflect.defineMetadata('api-config', nextMetadata, target, key);
    };
}
//# sourceMappingURL=decorators.js.map